// ===== ENVIRONMENT CONFIGURATION =====
// Set IS_LOCAL to true for local development, false for Azure deployment
export const IS_LOCAL = false;
export const LOG_LEVEL = 'info'; //'debug' or 'info'
export const INCLUDE_DEMO_LINK = false; // set to false to hide the demo button on the login page
export const INCLUDE_ABOUT_LINK = true;  // set to false to hide the "About this project" link on the login page
export const INCLUDE_ABOUT_PAGE = true;   // set to false to disable the about page — also update the flag in public/about/index.html


export const API_BASE_URL = IS_LOCAL 
  ? 'http://localhost:8080'
  : 'https://pythoninstructor-csadefauc8bcfmhx.centralus-01.azurewebsites.net';

export const PYTHON_INTERPRETER_URL = IS_LOCAL 
  ? 'http://localhost:6001' 
  : 'https://pythoninterpreter-fggmdkbxegeabpfd.centralus-01.azurewebsites.net';

// not being used anywhere yet, but can be used for links back to frontend from emails or other places  
export const FRONTEND_URL = IS_LOCAL
  ? 'http://localhost:3000'
  : 'https://pythoninstructorapp-hqh5bshcavere2b6.centralus-01.azurewebsites.net';
// =====================================

// ===== LOGGING CONFIGURATION =====
// Log levels: 'debug' = verbose (dev), 'info' = minimal (production)
//export const LOG_LEVEL = IS_LOCAL ? 'debug' : 'info';

let _isLoggingOut = false;
export const setLoggingOut = (val) => { _isLoggingOut = val; };

// ===== DEMO / GUEST MODE =====
// Lets the public browse the UI without an account. While active, every backend
// call through apiFetch is short-circuited so NO request reaches the server.
// SECURITY NOTE: this is a UX/cost guard only. Real enforcement lives on the
// backend — demo users never receive a JWT, so protected routes must 401 without
// a valid token even if someone flips this flag in devtools.
export const isDemoMode = () => localStorage.getItem('demoMode') === 'true';

export const enableDemoMode = () => {
  localStorage.setItem('demoMode', 'true');
  localStorage.setItem('isLoggedIn', 'true');
  localStorage.setItem('username', 'demo_guest');
  localStorage.setItem('userRole', 'user');
  localStorage.removeItem('jwtToken'); // never hold a real token in demo
  // Seed a default class so STATIC curriculum/slide files (served from /public)
  // resolve to a real folder (e.g. CIS3260-DEMO-GSU). These are not backend calls.
  localStorage.setItem('class_section', 'CIS3260-DEMO');
  localStorage.setItem('selected_section', 'CIS3260-DEMO');
  localStorage.setItem('university', 'GSU');
};

export const disableDemoMode = () => {
  localStorage.removeItem('demoMode');
};

// Synthetic response returned for any backend call attempted during demo mode.
// Shaped like a real fetch Response so callers using res.ok / res.json() still work.
const demoBlockedResponse = () => new Response(
  JSON.stringify({ error: 'demo_mode', message: 'Sign up or log in to use this feature.' }),
  { status: 403, statusText: 'Demo Mode', headers: { 'Content-Type': 'application/json' } }
);

export const apiFetch = async (url, options = {}) => {
  // Demo mode: never touch the backend
  if (isDemoMode()) {
    if (LOG_LEVEL === 'debug') console.log('🔒 [demo] blocked backend call:', url);
    return demoBlockedResponse();
  }

  const token = localStorage.getItem('jwtToken');
  const res = await fetch(url, {
    ...options,
    headers: {
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
  if (res.status === 401 && !_isLoggingOut) {
    localStorage.clear();
    window.location.reload();
  }
  return res;
};

export const logger = {
  debug: (...args) => {
    if (LOG_LEVEL === 'debug') console.log(...args);
  },
  info: (...args) => {
    console.log(...args);
  },
  error: (...args) => {
    console.error(...args);
  }
};
// =================================

